export const rootRoutes = {
	home: { label: "HOME", path: "/" },
	education: { label: "EDUCATION", path: "/education" },
	experience: { label: "EXPERIENCE", path: "/experience" },
	skills: { label: "SKILLS", path: "/skills" },
	portfolio: { label: "PORTFOLIO", path: "/portfolio" },
	blog: { label: "BLOG", path: "/blog" },
	contact: { label: "CONTACT", path: "/contact" },
};
